
  import { mapState } from 'vuex'
  import dataTable from '~/mixins/dataTable'
  export default {
    name: 'Theme2MissionMobileCoinHistoryPage',
    mixins: [dataTable],
    data() {
      return {
        openBottomFilter: false,
        api: 'activities/exchange-reward/getCoinHistories',
        sortBy: 'claim_time|desc',
        page: 1
      }
    },
    computed: {
      ...mapState({
        coinHistories: state => state.activities['exchange-reward'].coinHistories,
        missionsSettings: state => state.activities['mission-reward'].missionsSettings
      })
    },
    watch: {
      page(value) {
        this.customFilters.page = value
        this.API()
      }
    },
    mounted() {
      this.customFilters = {
        start_date: this.$dayjs().startOf('year').format('YYYY-MM-DD 00:00:00'),
        end_date: this.$dayjs().format('YYYY-MM-DD 23:59:59')
      }
      this.API()
    },
    methods: {
      async onSearch() {
        if (this.page > 1) {
          this.page = 1
        } else {
          await this.API()
        }
        this.openBottomFilter = false
      },
      onChangeStartDate(date) {
        this.customFilters.start_date = date
      },
      onChangeEndDate(date) {
        this.customFilters.end_date = date
      }
    }
  }
